export class LogTypes_New {
    constructor() {
        //actions = false;
        // doesn't actually log; rather, causes data to be stored in component.props.extraInfo.renderTriggers
        this.renderTriggers = false;
    }
}
export const logTypes = new LogTypes_New();
G({ logTypes }); // expose logTypes globally for console-editing, but don't mention to TS
if (localStorage.getItem("logTypes")) {
    logTypes.Extend(JSON.parse(localStorage.getItem("logTypes")));
}
g.addEventListener("beforeunload", () => {
    localStorage.setItem("logTypes", JSON.stringify(logTypes));
});
